import React from 'react';
import { BuyerOfferDocumentGroup } from '@/types';
import BuyerOfferDocumentGroupCard from './BuyerOfferDocumentGroupCard/BuyerOfferDocumentGroupCard';

interface BuyerOfferDocumentCardListProps {
    groups: BuyerOfferDocumentGroup[];
}

const BuyerOfferDocumentCardList: React.FC<BuyerOfferDocumentCardListProps> = ({ groups }) => {
    return (
        <>
            {groups.map((g) => (
                <BuyerOfferDocumentGroupCard key={g.offerId} documentGroup={g} />
            ))}
        </>
    );
};

export default BuyerOfferDocumentCardList;
